import {
    apiRequest,
    pensiunDetail,
    pensiunDocuments
} from "../../../../../services/adapters/kepegawaian/pensiunService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pensiunDetail, {
            params: query
        }, true)
    }

    fetchDocument = async (query) => {
        return await apiRequest("get", pensiunDocuments, {
            params: query
        }, true)
    }
}

export default DetailRepository